const LaboratoryMap: React.FC<{
  mapRef: React.RefObject<HTMLDivElement>;
}> = (props) => {
  return <div className="branches-info-map-container" ref={props.mapRef}></div>;
};

export default LaboratoryMap;
